<template>
  <span class="text-block">
    <slot>{{title}}</slot>
  </span>
</template>

<script>
  export default{
    props:{
      data:{
        type:Array,
        default(){
          return [
          ]
        }
      }
    },
    data(){
      return {
        title:''
      }
    },
    methods:{
    },
    mounted() {
    }
  }
</script>

<style lang="scss">
  .text-block{
   color:#71CFFF;
   border-radius: 2px;
   border: 1px solid #1B5590;
   font-size: 14px;
   padding:11px 14px;
   font-family: PingFangSC-Regular, PingFang SC;
   font-weight: 400;
   color: #71CFFF;
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/text-block.vue